module.exports = function() {
	return new Worker(__webpack_public_path__ + "1a10ac5b3de7c0e9e179.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader!./src/db/sqlite/worker.js
// module id = 8mQU
// module chunks = 1